import { useEffect } from "react";

import { useLastKnownTotal, useTableState } from "@/ds";
import { DEFAULT_OBRAS_SORT, isObrasSortField } from "@/modules/obras";
import { useObrasLista } from "../../hooks/use-obras-lista";
import type { ObrasListaViewProps, ObrasListaViewViewModel } from "./types-obras-lista-view";

export function useObrasListaView({
  search,
  filters,
  sort,
  onSort,
  settings,
  isMobile,
  onClearSearch,
  onClearFilters,
  onResult,
}: ObrasListaViewProps): ObrasListaViewViewModel {
  const { lastTotal, remember } = useLastKnownTotal();
  const pagina = useTableState({
    isSortField: isObrasSortField,
    total: lastTotal,
    resetKey: JSON.stringify([search.trim(), filters, sort]),
  });

  const { items, total, status, errorMessage, reload } = useObrasLista({
    search,
    filters,
    page: pagina.page + 1,
    pageSize: pagina.rows,
    sort: sort ?? DEFAULT_OBRAS_SORT,
  });
  remember(status, total);

  useEffect(() => {
    onResult({ status, total });
  }, [onResult, status, total]);

  return {
    search,
    filters,
    sort,
    settings,
    isMobile,
    onClearSearch,
    onClearFilters,
    items,
    total,
    status,
    errorMessage,
    reload,
    first: pagina.first,
    rows: pagina.rows,
    handlePage: pagina.onPage,
    handleSort: onSort,
  };
}
